<template>
  <div>
    <!-- bradcam_area_start -->
    <div
      v-if="
        this.$router.history.current['path'] == '/en/about' ||
        this.$router.history.current['path'] == '/fr/about' ||
        this.$router.history.current['path'] == '/about' 
      "
      
      class="bradcam_area breadcam_bg about_bg_1 overlay2"
    >
      <h3>{{ $t("about.name") }}</h3>


    </div>
    <!-- bradcam_area_end -->
    <!-- about_area_start -->
    <div ref="box" class="about_area" :class="this.$router.history.current['path'] == '/fr/about' || this.$router.history.current['path'] == '/en/about' || this.$router.history.current['path'] == '/about' ? 'about_page' : ''">
     
      <div class="container">
        <div class="row align-items-center">
          <div data-aos="fade-right" class="col-xl-6 col-lg-6">
            <div class="about_thumb">
              <img src="../img/about/about_lft.png" alt="Barbershop | salon de coiffure | صالون حلاقة" />
              <div class="opening_hour text-center">
                <i class="flaticon-clock"></i>
                <h3>{{ $t("about.hour") }}</h3>
                <p>
                  {{ $t("about.days") }} (10:00-22:00) <br />
                </p>
              </div>
            </div>
          </div>
          <div data-aos="fade-left" class="col-xl-6 col-lg-6">
            <div class="about_info">
              <div class="section_title mb-20px">
                <span>{{ $t("about.name") }}</span>
                <h3>
                  {{ $t("about.title1") }} <br />
                  {{ $t("about.title2") }}<br />
                  {{ $t("about.title3") }}
                </h3>
              </div>
              <p v-html="$t('about.text')"></p>
              <router-link :to="`/${$i18n.locale}/about`"
                ><a class="boxed-btn3">{{ $t("about.more") }}</a></router-link
              >
            </div>
          </div>
        </div>
      </div>

    </div>
    <Barbers
      data-aos="fade-up"
      class="added"
      v-if="
        this.$router.history.current['path'] == '/en/about' ||
        this.$router.history.current['path'] == '/fr/about' ||
        this.$router.history.current['path'] == '/about' 
      "
    ></Barbers>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/plugins/animation.gsap.min.js"></script>

<script>
import Barbers from "./layout/barbers.vue";

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();
// You can also pass an optional settings object
// below listed default settings
AOS.init({
  // Global settings:
  duration: 900, // values from 0 to 3000, with step 50ms
});

export default {
  data() {
    return {
      // isHidden: false
    };
  },
  created() {
    AOS.init();
  },

  components: {
    Barbers,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_responsive.scss";
@import "../styles/_mixins.scss";
@import "../styles/_varriable.scss";
@import "../styles/_reset.scss";
@import "../styles/_bradcam.scss";
@import "../styles/_btn.scss";
@import "../styles/_section_title.scss";
@import "../styles/pages/_about.scss";
.about-wave{
     height: 150px;
    overflow: hidden;
    position: absolute;
    bottom: 231px;
    width: 100%;
}
.hidden {
  display: none !important;
}
.about_page{
  padding-bottom: 0;
}
</style>
